import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog, { isPostHogActive } from '@/lib/posthog';
import { track } from '@/lib/tracker';

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Skip admin routes — those aren't customer-visible "visits" and would
    // otherwise inflate our storefront visitor analytics.
    if (location.pathname.startsWith('/admin')) return;

    // First-party page_view — powers the /admin/analytics/visitors chart
    // (Phase 123). Debounced at 2s inside tracker.js to absorb rapid
    // back/forward navigation without duplicate writes.
    track('page_view', {
      path: location.pathname,
      search: location.search,
    });

    if (isPostHogActive) {
      posthog.capture('$pageview', {
        path: location.pathname,
        search: location.search,
      });
    }

    // Meta Pixel page view
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }

    // GA4 page view
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        page_search: location.search,
      });
    }
  }, [location]);

  return null;
}
